const SYNCED_ACTIONS = [
    'ADD_DOCUMENT_JOB',
    'UPDATE_DOCUMENT_JOB',
    'UPDATE_DOCUMENT_JOB_ITEM',
    'REMOVE_DOCUMENT_JOB',
    'CLEAR_FINISHED_DOCUMENT_JOBS',
    'SET_DOCUMENT_JOBS_TRAY_OPEN',
    'SET_DOCUMENT_JOBS_MODAL_JOB',
]

let channel = null

const getChannel = () => {
    if (!channel && typeof BroadcastChannel !== 'undefined') {
        channel = new BroadcastChannel('pulsawork_document_jobs_sync')
    }
    return channel
}

export const documentJobsSyncMiddleware = (store) => (next) => (action) => {
    const result = next(action)
    if (SYNCED_ACTIONS.includes(action.type) && !action._synced) {
        try {
            const ch = getChannel()
            if (ch) ch.postMessage({ ...action, _synced: true })
        } catch (e) {}
    }
    return result
}

export const setupDocumentJobsSyncListener = (store) => {
    const ch = getChannel()
    if (!ch) return
    ch.onmessage = (event) => {
        const action = event.data
        if (action && SYNCED_ACTIONS.includes(action.type) && action._synced) {
            store.dispatch(action)
        }
    }
}
